<div class="col-md-12">
  <h3 class="">User Management</h3>  
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
  <br />
  <div class="panel panel-primary">
    <div class="panel-heading">Add/Remove User/Admin</div>
    <div class="panel-body">
  <div class="form">
    <form name="form" (ngSubmit)="f.form.valid && OnSubmit()" #f="ngForm"  novalidate>
  <div class="form-group row">
  <label for="ProvisioningID" class="col-sm-2 col-form-label">Provisioning ID</label>
  <div class="col-sm-4">

      <input  id="ProvisioningID" placeholder="User ProvisioningID"  (selectItem)="selectedItem($event)" name ="ProvisioningID" type="text" class="form-control" [(ngModel)]="ProvisioningID" [ngbTypeahead]="searchUserProvisioningID" #UserProvisioningID="ngModel" [ngClass]="{ 'is-invalid': f.submitted && UserProvisioningID.invalid }" required/> 
      <div *ngIf="f.submitted && UserProvisioningID.invalid" class="invalid-feedback invalid-display">
              <div *ngIf="UserProvisioningID.errors?.['required']">*User ProvisioningID is required</div>
      </div> 
  </div>
  
  </div>
  <div class="form-group row">
  <label for="UserName" class="col-sm-2 col-form-label">Name</label>
 
  <div class="col-sm-4">
    <input type="text" [(ngModel)]="Name"  [readonly]="true"  class="form-control" id="UserName" placeholder="Name" name ="UserName" #UserName="ngModel"
    [ngClass]="{ 'is-invalid': f.submitted && UserName.invalid }" required>
  <div *ngIf="f.submitted && UserName.invalid" class="invalid-feedback invalid-display">
    <div *ngIf="UserName.errors?.['required']">*User Name is required</div>
  </div>
  </div>
  </div>
  
  <div class="form-group row">
      <label for="UserEmail" class="col-sm-2 col-form-label">Email</label>
      <div class="col-sm-4">
              <input type="text" class="form-control" [readonly]="true" [(ngModel)]="Email" id="UserEmail" placeholder="Email" name ="UserEmail" #UserEmail="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && UserEmail.invalid }" required>
          <div *ngIf="f.submitted && UserEmail.invalid" class="invalid-feedback invalid-display">
              <div *ngIf="UserEmail.errors?.['required']">*User Email is required</div>
      </div>
      </div>
      </div>
  
      <div class="form-group row">
              <label for="UserAccessType" class="col-sm-2 col-form-label">Access Type</label>
              <div class="col-sm-4">
                      <select id="UserAccessType" name ="UserAccessType" class="form-control" [(ngModel)]="Role" (change)="Selected()" #UserAccessType="ngModel" [ngClass]="{ 'is-invalid': f.submitted && UserAccessType.invalid }" required>
                          <option value="" selected>Select</option>
                              <option *ngFor="let role of AccessRole" [ngValue]="role.Name" >{{role.Name}}</option>
                            </select>
                            <div *ngIf="f.submitted && UserAccessType.invalid" class="invalid-feedback invalid-display">
                                <div *ngIf="UserAccessType.errors?.['required']" >*Access Type is required</div>
                </div>
              </div>
              </div>
  
      <div class="form-group row">
          <div class="col-sm-2">
              </div>
          <div class="col-sm-2 ">
          <button class="btn btn-primary " >{{SaveUpdate}}</button> 
          </div>
          <div class="col-sm-2 ">
              <button class="btn btn-primary" style="text-align:right" (click)="initForm()" >Reset Form</button> 
              </div>
          </div>
  
  
        </form>      </div>
  </div>
  </div>
  <div class="clearfix"></div>
    <br /> <br />
    <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">ProvisioningID</th>
          <th scope="col">Name</th>
          <th scope="col">Role</th>
          <th scope="col">EmailID</th>
          <th colspan="2" scope="col" >Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of viewUsers | paginate: config">
          <td>{{ user.ProvisioningID }}</td>
          <td>{{ user.Name }}</td>
          <td>{{ user.Role }}</td>
          <td>{{ user.Email }}</td>
          <td colspan="2">
            <a (click) = "deleteConfirm(user)" class="btn btn-danger">Delete</a>
            <a  style="margin-left: 20px;" (click) = "editUser(user)" class="btn btn-primary">Edit</a>
          </td>
          
        </tr>
      </tbody>
    </table>
    <pagination-controls  (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
  
  